import TeamOutlined from '@ant-design/icons/TeamOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
// assets
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import LoginOutlined from '@ant-design/icons/LoginOutlined';
import PhoneOutlined from '@ant-design/icons/PhoneOutlined';
import NotificationOutlined from '@ant-design/icons/NotificationOutlined';
import HistoryOutlined from '@ant-design/icons/HistoryOutlined';
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import RocketOutlined from '@ant-design/icons/RocketOutlined';
import { ContactSupportOutlined, Event } from '@mui/icons-material';
import { HouseOutlined } from '@mui/icons-material';
import { MapOutlined } from '@mui/icons-material';
// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  DollarOutlined,
  LoginOutlined,
  PhoneOutlined,
  RocketOutlined,
  HistoryOutlined,
  QuestionCircleOutlined,
  ContactSupportOutlined,
  HouseOutlined,
  MapOutlined,
  NotificationOutlined,
  TeamOutlined,
  FileTextOutlined,
  Event
};

// ==============================|| MENU ITEMS - PAGES ||============================== //

const management: NavItemType = {
  id: 'group-pages',
  title: 'Management',
  type: 'group',
  divider: true, // no HR before this group
  children: [
    {
      id: 'announcements',
      title: 'Announcements',
      type: 'item',
      url: '/announcements',
      icon: icons.NotificationOutlined,
      target: false
    },
    {
      id: 'properties',
      title: 'Properties',
      type: 'item',
      url: '/properties',
      icon: icons.HouseOutlined,
      target: false,
      permission: 'canViewProperties'
    },
    {
      id: 'directory',
      title: 'Directory',
      type: 'item',
      url: '/directory',
      icon: icons.TeamOutlined,
      target: false,
      permission: 'canViewDirectory'
    },
    {
      id: 'documents',
      title: 'Documents',
      type: 'item',
      url: '/documents',
      icon: icons.FileTextOutlined,
      target: false
    },
    {
      id: 'requests',
      title: 'Requests',
      type: 'item',
      url: '/requests',
      icon: icons.ContactSupportOutlined,
      target: false,
      permission: 'canViewTickets'
    },
    {
      id: 'violations',
      title: 'Violations',
      type: 'item',
      url: '/violations',
      icon: icons.RocketOutlined,
      target: false,
      permission: 'canViewTickets'
    },
    {
      id: 'form-templates',
      title: 'Form Templates',
      type: 'item',
      url: '/form-templates',
      icon: icons.FileTextOutlined,
      target: false,
      permission: 'canManageFormTemplates'
    },
     {
      id: 'events',
      title: 'Events',
      type: 'item',
      url: '/events',
      icon: icons.Event,
      target: false,
      permission: 'canViewEvents'
    }
  ]
};

export default management;
